<template>
  <Flex
    :direction="'column'"
    :gap="2"
  >
    <BaseText center>
      {{ description }}
    </BaseText>
    <BaseForm @submit="sendCode">
      <Flex :direction="'column'">
        <div :class="$style.inputWrap">
          <BaseCodeInput
            v-model="token"
            :label="$t(`${baseName}.enter_code`)"
            type="text"
            name="token"
            required
            v-test="`${baseName}-token`"
          />
        </div>
        <BaseText
          v-if="tokenError"
          color="error"
          v-test="'tokenError'"
          :center="true"
        >
          {{ $t(`${baseName}.token_error`) }}
        </BaseText>
        <div :class="$style.bottom">
          <BaseButton
            :loading="isLoading"
            center
            submitForm
            v-test="`${baseName}-submit`"
          >
            {{ $t(`${baseName}.verify_code`) }}
          </BaseButton>
          <div>
            <BaseText
              center
              :href="helpPageUrl"
              v-test="'token-info'"
            >
              {{ $t('two_factor.info') }}
            </BaseText>
          </div>
        </div>
      </Flex>
    </BaseForm>
  </Flex>
</template>

<script lang="ts">
import useVuelidate from '@vuelidate/core';
import { defineComponent } from 'vue';
import { helpCenterArticleUrl } from '@/helpers/help-center';

export default defineComponent({
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    tokenError: {
      type: Boolean,
      required: true,
    },
    baseName: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
  emits: ['sendCode'],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      token: '',
    };
  },
  watch: {
    token() {
      if (this.token.length === 6) {
        this.$emit('sendCode', this.token);
      }
    },
  },
  computed: {
    helpPageUrl() {
      return helpCenterArticleUrl(6115892);
    },
  },
  methods: {
    sendCode() {
      this.v$.$touch();

      if (this.v$.$invalid) {
        return;
      }
      this.$emit('sendCode', this.token);
    },
  },
});
</script>

<style
  lang="scss"
  module
>
.bottom {
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: $spacing;
}

.inputWrap {
  display: flex;
  justify-content: center;
}
</style>
